// ============================================================
// CSV Export Utilities — 通用 CSV 匯出工具
// ----------------------------------------------------------
// 說明：
//   - 支援中文（自動加 BOM 讓 Excel 正確顯示）
//   - 自動處理含逗號、換行、引號的欄位（加引號並轉義）
//   - 直接觸發瀏覽器下載
// ============================================================

/**
 * 將陣列轉 CSV 字串（單一欄位自動加引號/轉義）
 */
function escapeCell(val: unknown): string {
  if (val === null || val === undefined) return '';
  const s = String(val);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/**
 * 產生 CSV 字串
 * @param headers 欄位名稱陣列（第一列）
 * @param rows 資料陣列（二維）
 */
export function buildCSV(headers: string[], rows: (string | number | null | undefined)[][]): string {
  const lines = [headers.map(escapeCell).join(',')];
  for (const r of rows) {
    lines.push(r.map(escapeCell).join(','));
  }
  return lines.join('\r\n');
}

/**
 * 觸發下載 CSV（含 UTF-8 BOM 讓 Excel 正確解碼中文）
 */
export function downloadCSV(filename: string, csv: string): void {
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * 一步式：給資料直接下載
 */
export function exportCSV(
  filename: string,
  headers: string[],
  rows: (string | number | null | undefined)[][]
): void {
  downloadCSV(filename, buildCSV(headers, rows));
}
